module.exports = __webpack_public_path__ + "img/etabs.bb2e188a.png";